angular.module('eStories.grid-4-carousel.compnt', [
    'eStories.common.directives',
    'eStories.carousel.service',
    'eStories.catalog.model',
    'eStories.compnt.starRating',
    'eStories.compnt.grid'
])

    .component('fourCarousel', {
        transclude: true,
        bindings: {
            data: '<',
            section: '<'
        },
        controller: 'CarouselFourCtrl',
        controllerAs: 'carouselFourCtrl',
        templateUrl: 'components/templates/carousels/4-grid-carousel/grid-4-carousel.tmpl.html'
    })


    .controller('CarouselFourCtrl', [
        '$window',
        '$rootScope',
        '$scope',
        '$state',
        'CarouselService',
        function ($window,
                  $rootScope,
                  $scope,
                  $state,
                  CarouselService) {

            this.currentState = $state.current.name;

            this.getAudiobookObj = book => CarouselService.getAudiobookObj(book);

            const panelLength = 4;
            //noinspection JSUnusedGlobalSymbols
            this.$onChanges = (changes) => {
                this.data = changes.data.currentValue;
                this.pagination = new CarouselPagination(this.data, panelLength, $window);
            };
            this.pagination = new CarouselPagination(this.data, panelLength, $window);
        }
    ]);